/**
 * Backend contract (offline submissions): every contribution carries
 * `Idempotency-Key`, generated once and reused for each resend, and
 * `X-Recorded-At`, when it was made on the device. A server that predates the
 * contract ignores both.
 */

export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';
export const RECORDED_AT_HEADER = 'X-Recorded-At';

const KEY_PATTERN = /^[A-Za-z0-9_-]{8,64}$/;

/** A random UUID, also on browsers without crypto.randomUUID (Safari before 15.4). */
export function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** 36 characters of [0-9a-f-]: inside the 8-64 [A-Za-z0-9_-] the server accepts. */
export const newIdempotencyKey = (): string => randomId();

export const isValidIdempotencyKey = (key: string) => KEY_PATTERN.test(key);

export type SubmissionHeaders = Record<typeof IDEMPOTENCY_KEY_HEADER | typeof RECORDED_AT_HEADER, string>;

export function submissionHeaders(idempotencyKey: string, recordedAt: string): SubmissionHeaders {
  return { [IDEMPOTENCY_KEY_HEADER]: idempotencyKey, [RECORDED_AT_HEADER]: recordedAt };
}
